export function roundUp(number: number, decimals: number): number {
  const decimalsFactor = 10;
  const factor = Math.pow(decimalsFactor, decimals);
  return Math.ceil(number * factor) / factor;
}
